import type ModelRegistry from 'ember-data/types/registries/model';
import ApplicationAdapter from 'volta/_pods/application/adapter';

export default class ForecastProjectTaskAdapter extends ApplicationAdapter {
  pathForType<K extends keyof ModelRegistry>(_modelName: K): string {
    return 'forecastProjects/tasks';
  }
}
